/**
 * @file badge.component.tsx
 * @description Form-control обертка для работы с UI StateBadge компонентом в react-hook-form
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, react-hook-form, @components/ui/indicators/state-badge]
 * @related-files [@components/ui/indicators/state-badge/state-badge.component.tsx]
 */

import { Control, Controller, FieldValues } from 'react-hook-form';
import { StateBadge } from '@components/ui/indicators/state-badge';

/**
 * Props для form-control компонента Badge с интеграцией react-hook-form
 */
interface IBadge extends Omit<React.ComponentProps<typeof StateBadge>, 'state'> {
    /** Control объект из react-hook-form для управления формой */
    control: Control<FieldValues>;
    /** Имя поля в форме */
    name: string;
}

export const Badge = ({ control, name, ...props }: IBadge) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => field.value?.id && <StateBadge {...props} state={field.value} />}
        />
    );
};
